import {ClassQueries} from '../../api/class'

export const ClassService = {queries: ClassQueries}
